import { ComponentProps } from "@declarations/props";
import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useLocation, useNavigate } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";
import { BiFilterAlt, BiLogOut } from "react-icons/bi";
import { useState } from "react";
// import { PopupConfirm } from "@components/general/popup";
// import Cookies from "js-cookie";

export const Header: ComponentProps<{
  height?: number;
  // classOverlay?: string;
}> = ({ children, height = 210 }) => {
  return <>{children ?? <PageTitle />}</>;
};

const PageTitle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { header, setPopupStatus } = useThemeStore((state) => state);
  // const [popupLogout, setPopupLogout] = useState<boolean>(false);

  return (
    <>
      {location.pathname === linkPage.HOME_DASHBOARD ? (
        ""
      ) : (
        <div className={`tw-pt-4 tw-pb-6 tw-text-other-100 page-header`}>
          <div className="tw-flex tw-items-center tw-px-4">
            {header.filter && (
              <div
                className="tw-flex tw-shrink-0 tw-items-center"
                onClick={() => setPopupStatus(true)}
              >
                <BiFilterAlt size={25} />
              </div>
            )}

            {header.buttonBack && (
              <span
                onClick={() => navigate(-1)}
                className="tw-p-1 tw-pe-2 tw-flex tw-items-center tw-cursor-pointer"
              >
                <FaChevronLeft size={20} />
              </span>
            )}

            <div className="tw-grow tw-text-left">
              <div className="tw-text-2xl tw-font-medium">
                {header.title ?? <>Nama Halaman</>}
              </div>
            </div>

            {/* {header.buttonLogout && (
              <div
                className="tw-flex tw-shrink-0 tw-items-center"
                onClick={() => setPopupStatus(true)}
              >
                <BiLogOut size={25} />
              </div>
            )} */}
          </div>
        </div>
      )}
    </>
  );
};
